import React from 'react';
import { Col, Row } from "antd";
import { InputToolItem } from './InputToolItem';
import { tRow } from '../../../assets/libs/i18n/translator';

const RowDefaultPropertiesPanel = ({ rowSeatSpacing, rowSeatSpacingHandler, rowSeatSize, rowSeatSizeHandler }) => {
    const items = [
        {
            label: tRow("seatsSpacing"),
            value: rowSeatSpacing,
            onChange: rowSeatSpacingHandler,
        },
        {
            label: tRow("seatSize"),
            value: rowSeatSize,
            onChange: rowSeatSizeHandler,
            min: 10,
        },
    ];

    return (
        <Row>
            <Col span={24} className="mb-2">
                <h3>{tRow("rowConfig")}</h3>
            </Col>

            {items.map((item, index) => (
                <InputToolItem key={index} {...item} />
            ))}
        </Row>
    );
};

export { RowDefaultPropertiesPanel }